import { initialBaseState } from './base';
import { navigationInitialState } from './navigation';
import { servicesInitialState } from './services';
import { AppState } from './store';
import { tempDataInitialState } from './tempData';
import { tokenDataInitialState } from './tokenData';
import { userInputInitialState } from './userInput';

export const initialStateMock: AppState = {
	baseState: {
		...initialBaseState,
	},
	servicesState: {
		...servicesInitialState,
	},
	userInputState: {
		...userInputInitialState,
	},
	navigationState: {
		...navigationInitialState,
	},
	tempDataState: {
		...tempDataInitialState,
	},
	tokenDataState: {
		...tokenDataInitialState,
	},
};
